import React from 'react'
import '../../styles/gallery/main.css';

const Main = () => {
  return (
    <div>
        <section className="gallery-main">
        <div className="container">
            <h1 className="my-heading mb-3">ACADEMIC GALLERY</h1>
            <ul>
            <li>
                <a data-bs-toggle="modal" href="#exampleModalToggle" role="button" className="btn-gallery">
                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/1.jpg" alt="gallery" />
                </a>
                <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle" role="button">View More</a>
                <div>
                <h6>Department</h6>
                </div>
            </li>

            <li>
                <a data-bs-toggle="modal" href="#exampleModalToggle2" role="button" className="btn-gallery">
                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/1.jpg" alt="gallery" />
                </a>
                <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle2" role="button">View More</a>
                <div>
                    <h6>Hostels</h6>
                </div>
            </li>
            <li>
                <a data-bs-toggle="modal" href="#exampleModalToggle3" role="button" className="btn-gallery">
                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/computer-labs/1.jpg" alt="gallery" />
                </a>
                <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle3" role="button">View More</a>
                <div>
                    <h6>Computer Labs</h6>
                </div>
            </li>
            <li>
                <a data-bs-toggle="modal" href="#exampleModalToggle4" role="button" className="btn-gallery">
                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/1.jpg" alt="gallery" />
                </a>
                <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle4" role="button">View More</a>
                <div>
                    <h6>Laboratories</h6>
                </div>
            </li>
            </ul>
        </div>
        </section>

        <div className="modal-main">
            <div className="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                tabindex="-1">
                <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/1.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/2.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/3.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/4.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/5.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/6.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/7.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/8.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/9.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/10.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/12.jpg" className="d-block w-100" alt="Department" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/12.jpg" className="d-block w-100" alt="Department" />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                    <div className="close-btn-modal">
                        <button data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa fa-times" aria-hidden="true" style={{cursor: 'pointer'}}></i>
                        </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <div className="modal-main">
            <div className="modal fade" id="exampleModalToggle2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                tabindex="-1">
                <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div id="carouselExampleControls2" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/1.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/2.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/3.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/4.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/5.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/6.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/7.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/8.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Hostels/9.jpg" className="d-block w-100" alt="Hostel" />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls2"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls2"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                    <div className="close-btn-modal">
                        <button data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa fa-times" aria-hidden="true" style={{cursor: 'pointer'}}></i>
                        </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <div className="modal-main">
            <div className="modal fade" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                tabindex="-1">
                <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div id="carouselExampleControls3" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/computer-labs/1.jpg" className="d-block w-100" alt="computer-labs" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/computer-labs/2.jpg" className="d-block w-100" alt="computer-labs" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/computer-labs/3.jpg" className="d-block w-100" alt="computer-labs" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/computer-labs/4.jpg" className="d-block w-100" alt="computer-labs" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/computer-labs/5.jpg" className="d-block w-100" alt="computer-labs" />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls3"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls3"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                    <div className="close-btn-modal">
                        <button data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa fa-times" aria-hidden="true" style={{cursor: 'pointer'}}></i>
                        </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <div className="modal-main">
            <div className="modal fade" id="exampleModalToggle4" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                tabindex="-1">
                <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div id="carouselExampleControls4" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/1.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/2.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/3.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/4.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/5.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/6.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/7.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/8.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/9.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/11.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/12.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/13.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/14.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/15.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/16.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/17.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/18.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/19.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                        <div className="carousel-item">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/laboratories/20.jpg" className="d-block w-100" alt="laboratories" />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls4"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls4"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                    <div className="close-btn-modal">
                        <button data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa fa-times" aria-hidden="true" style={{cursor: 'pointer'}}></i>
                        </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

    </div>
  )
}

export default Main;